import { ReactElement } from 'react'
import BlockIcon from '@mui/icons-material/Block'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { Stack, Typography } from '@mui/material'
import { DecidedChange, DecidedChangeOutcome } from '../utils'

interface Props {
  change: DecidedChange
}

const OUTCOMES: Record<
  DecidedChangeOutcome,
  { label: string; fileLabel: string; color: string; icon: typeof CheckCircleOutlineIcon }
> = {
  approved: {
    label: 'Freigegeben',
    fileLabel: 'Hochgeladen',
    color: 'success.main',
    icon: CheckCircleOutlineIcon,
  },
  denied: { label: 'Abgelehnt', fileLabel: 'Ohne Datei', color: 'text.secondary', icon: BlockIcon },
  not_executed: {
    label: 'Nicht ausgeführt',
    fileLabel: 'Nicht ausgeführt',
    color: 'text.secondary',
    icon: RemoveCircleOutlineIcon,
  },
  failed: {
    label: 'Fehlgeschlagen',
    fileLabel: 'Fehlgeschlagen',
    color: 'error.main',
    icon: ErrorOutlineIcon,
  },
}

/** One decided change in the chat history: what it was and how it was decided (`decidedChangeOf`). */
const DecidedChangeSummary = ({ change }: Props): ReactElement => {
  const { label, fileLabel, color, icon: Icon } = OUTCOMES[change.outcome]

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={0.75}
      sx={{ border: 1, borderColor: 'divider', borderRadius: 1, px: 1, py: 0.5, my: 0.5 }}
      data-cy="ai-chat-decided-change"
    >
      <Icon fontSize="small" sx={{ color, mt: '1px' }} />
      <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }}>
        {change.title}
      </Typography>
      <Typography variant="caption" sx={{ color, whiteSpace: 'nowrap', lineHeight: '20px' }}>
        {change.isFileRequest ? fileLabel : label}
      </Typography>
    </Stack>
  )
}

export default DecidedChangeSummary
